(function (app, ng) {

    function ColorPalette(_) {

        //private properties
        var colors = [
            {
                id: 0,
                name: "Red",
                hexCode: "#ff3C2e"
            },
            {
                id: 1,
                name: "Teal",
                hexCode: "#4dd7fa"
            },
            {
                id: 2,
                name: "Blue",
                hexCode: "#00439e"
            },
            {
                id: 3,
                name: "Orange",
                hexCode: "#ffa848"
            },
            {
                id: 4,
                name: "Green",
                hexCode: "#568c77"
            },
            {
                id: 5,
                name: "Purple",
                hexCode: "#a555a6"
            }
        ];

        var defaultColor = colors[0];
        var userDefinedDefaultColor;

        //constructor
        function ColorPalette(defaultColorName) {
            userDefinedDefaultColor = findColorByName(defaultColorName);
            if (typeof userDefinedDefaultColor === "undefined") {
                userDefinedDefaultColor = defaultColor;
            }

        }

        //private functions
        function findColorByName(name) {
            return _.find(colors,
                function (color) {
                    return color.name === name;
                });
        }

        function findColorByHexCode(hexCode) {
            return _.find(colors,
                function (color) {
                    return color.hexCode === hexCode;
                });
        }

        //public functions
        ColorPalette.prototype.getColorByName = function (name) {
            var color = findColorByName(name);
            if (!!color) {
                return color;
            } else {
                return userDefinedDefaultColor;
            }
        };

        ColorPalette.prototype.getColorByHexCode = function (hexCode) {
            var color = findColorByHexCode(hexCode);
            if (!!color) {
                return color;
            } else {
                return userDefinedDefaultColor;
            }

        };

        ColorPalette.prototype.getColors = function () {
            return ng.copy(colors);
        };

        return ColorPalette;

    }

    ColorPalette.$inject = ["_"];
    app.factory("ColorPalette", ColorPalette);

})(window.app, window.angular); //jshint ignore:line
